import { render, staticRenderFns } from "./filterBlock.vue?vue&type=template&id=3f5f814f&scoped=true"
import script from "./filterBlock.vue?vue&type=script&lang=js"
export * from "./filterBlock.vue?vue&type=script&lang=js"
import style0 from "./filterBlock.vue?vue&type=style&index=0&id=3f5f814f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5f814f",
  null
  
)

export default component.exports